import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import config from "./config";
import pixels from "./pixels";
import MQ from "vue-match-media/src";
import VueLogger from "vuejs-logger";
import VueAnalytics from "vue-analytics";
import AdobeLaunch from "./plugins/adobe-launch";
import HTMLSanitize from "./plugins/html-sanitize";
import formValidator from "./mixins/form-validator";

// Vue Logger
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: PRODUCTION ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
});

// Configuración del módulo
Vue.use(config);
Vue.use(AdobeLaunch);

// Media queries
Vue.use(MQ);

// Pixeles
// (llamar al último)
Vue.use(pixels);

/**
 * Directiva para sanitizar HTML con DOMPurify
 * Necesario para evitar XSS (detectado por Sonar9)
 */
Vue.use(HTMLSanitize);

/**
 * Instanciar la app luego de obtener y
 * aplicar la configuración del módulo
 */
config.start(() => {
  // Inicializar la app
  const BBVA_APP = new Vue({
    router,
    store,
    mixins: [formValidator],
    mq: {
      medium: "(max-width: 1060px) and (min-width: 600px)",
      small: "(max-width: 600px)"
    },
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
  }).$mount("#app");

  // Google Analytics
  // Necesitamso el config del id
  // por eso llamamos acá
  /*istanbul ignore else*/
  if (config.get() && config.get().googleAnalyticsId) {
    Vue.use(VueAnalytics, {
      id: config.get().googleAnalyticsId,
      router,
      autoTracking: {
        exception: true,
        pageviewOnLoad: false
      }
    });
  }

  // Agregar timestamp de versionado si existe
  let app_version = _BBVA_VERSION || null;
  /*istanbul ignore else*/
  if (app_version) {
    BBVA_APP.version = app_version;
  }

  // Exponemos la instancia al scope global
  // Útil para hacer modificaciones desde afuera
  window.BBVA_APP = BBVA_APP;
  return BBVA_APP;
});
